import React from 'react';
import { ResourceContent } from '.';
import { rawSafeHtmlProps, getConfigurationDataKey } from '../utils';

export const AdditionalSupport = () => {
  return (
    <div className='d-flex'>
      <p className='add-support'>
        <ResourceContent contentKey='service-request.additional-support.title' />
      </p>
      <p className='mx-2'>
        <ResourceContent
          contentKey={getConfigurationDataKey('service-request.additional-support.body')}
          sourceDataKey='content'
          render={(body) => <span {...rawSafeHtmlProps((body ?? '')?.toString())} />}
        />
      </p>
    </div>
  );
};
